<template>
    <select :id="id" ref="select" :value="value" class="form-control" :class="{ invalid: error }" @change="update">
        <option :value="null" :disabled="disableDefault">
            {{ placeholder }}
        </option>
        <option v-for="(item, index) in list" :key="`${item[valueKey]}${index}`" :value="item[valueKey]"
            :selected="item[valueKey] == value" :disabled="item.disabled">
            {{ item[labelKey] }}
        </option>
    </select>
</template>

<script>
export default {
    name: 'SelectList',
    props: {
        id: String,
        value: {
            default: null
        },
        list: {
            type: Array,
            default: () => []
        },
        valueKey: {
            type: String,
            default: 'value'
        },
        labelKey: {
            type: String,
            default: 'label'
        },
        error: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: 'Select an option'
        }
    },
    data() {
        return {
            disableDefault: false
        };
    },
    mounted() {
        this.update({ target: { value: this.value } });
    },
    watch: {
        value(newValue, oldValue) {
            if (oldValue != null) {
                this.update({ target: { value: this.value } });
            }
        }
    },
    methods: {
        update({ target }) {
            this.disableDefault = true;

            this.$emit('input', target.value);
            this.$emit('change', target.value);
        },
        isNum(val) {
            return !isNaN(val);
        }
    }
};
</script>

<style lang="scss"></style>
